import { httpV2 } from "../http.js";

const InspectionBoardService = {
  list: (params = {}) =>
    httpV2.get("/inspection-board", { params }),
  upsert: (guest_reservation_id, body) =>
    httpV2.put(`/inspection-board/${guest_reservation_id}`, body),
};

export default InspectionBoardService;
